import { normalizeListFilters, toFilterSelectId } from './filterDateUtils';

export const TASKS_LIST_STATE_KEY = 'crm:tasks:listState';

export const captureTasksListState = (state) => {
  if (!state) return null;
  return {
    filters: state.filters ? normalizeListFilters(state.filters) : state.filters,
    searchText: state.searchText ?? '',
    viewMode: state.viewMode ?? 'kanban',
    pagination: state.pagination ?? { current: 1, pageSize: 10 },
    filterLabels: state.filterLabels && typeof state.filterLabels === 'object'
      ? state.filterLabels
      : {},
    assignedToAll: state.assignedToAll === true,
  };
};

export const loadTasksListState = () => {
  try {
    const raw = sessionStorage.getItem(TASKS_LIST_STATE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const saveTasksListState = (state) => {
  const snapshot = captureTasksListState(state);
  if (!snapshot) return;
  try {
    sessionStorage.setItem(TASKS_LIST_STATE_KEY, JSON.stringify(snapshot));
  } catch {
    /* ignore quota */
  }
};
